import logoMark from '../assets/logo-mark.png';

export function Logo({ size = 28, withText = true }: { size?: number; withText?: boolean }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
      <img src={logoMark} alt="Mon Extra" width={size} height={size} style={{ display: 'block', flexShrink: 0 }} />
      {withText && (
        <span style={{ fontSize: size * 0.7, fontWeight: 800, color: 'var(--accent-dark)', whiteSpace: 'nowrap' }}>
          Mon Extra
        </span>
      )}
    </div>
  );
}
